<template>
	<div class="container">
		<div class="content">
			<div class="card mb_0">
				<h3 id="selectAsset" class="title mb_15">
					{{ $t('rtr_pay-payment.title1') }}
				</h3>
				<div class="mb_20">
					<AccountPicker @changeAccount="getAccountInfo"></AccountPicker>

					<div v-if="isSelectedAccount" class="bg_black_box">
						<div class="d_flex flex_column">
							<div class="asset_box">
								<span
									:class="[selectedAccountInfo?.asset_code, 'small']"
								></span>
								<p class="code mr_4">{{ selectedAccountInfo?.asset_code }}</p>
								<p class="name">{{ selectedAccountInfo?.asset_title }}</p>
							</div>
							<span class="divide_line"></span>
							<div class="num_unit">
								<p class="num">{{ selectedAccountInfo?.balance }}</p>
								<p class="unit">{{ selectedAccountInfo?.asset_code }}</p>
							</div>
						</div>
					</div>
				</div>
				<h3 id="selectWay" class="title mb_15">
					{{ $t('rtr_pay-payment.title2') }}
				</h3>
				<div class="mb_20">
					<swiper
						:slidesPerView="1.5"
						:space-between="10"
						:modules="modules"
						class="mb_15"
					>
						<swiper-slide v-if="0" id="radio1">
							<div>
								<input
									type="radio"
									id="way3"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way3"
									@click="selectWay"
								/>
								<label for="way3" class="box type_01">
									<span class="coin_icon way_03"></span>
									<span class="coin_name">
										{{ $t('rtr_pay-payment.text3') }}
									</span>
								</label>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div>
								<input
									type="radio"
									id="way1"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way1"
									@click="selectWay"
								/>
								<label for="way1" class="box type_01">
									<span class="coin_icon way_01"></span>
									<span class="coin_name">
										{{ $t('rtr_pay-payment.text1') }}
									</span>
								</label>
							</div>
						</swiper-slide>
						<swiper-slide
							v-if="
								!selectedAccountInfo ||
								['USDT', 'USOT'].indexOf(selectedAccountInfo?.code) !== -1
							"
						>
							<div>
								<input
									type="radio"
									id="way2"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way2"
									@click="selectWay"
								/>
								<label for="way2" class="box type_01">
									<span class="coin_icon way_02"></span>
									<span class="coin_name">
										{{ $t('rtr_pay-payment.text2') }}
									</span>
								</label>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM v-if="showTab === 'way1'" @closeModal="closeWayModal">
		<template #title>
			<h3 class="modal_title_m mb_16">{{ $t('rtr_pay-payment.text1') }}</h3>
		</template>
		<div class="registration_wrap mb_40">
			<p class="mb_8 tal">{{ $t('rtr_pay-payment.text4') }}</p>
			<div class="mb_16">
				<div class="d_flex align_items_center mb_4">
					<div class="search_area w100 flex1 mr_8">
						<input
							type="text"
							:placeholder="$t('rtr_pay-payment.text5')"
							v-model="toAccountNumber"
							@keydown.enter="findAccountInfo"
							@change="findAccountInfo"
							@focusin="showQrReader = false"
						/>
						<a class="search_icon SEARCH" @click="findAccountInfo"></a>
					</div>
					<span class="CAMERA" @click="initQrReader = true"></span>
				</div>
				<span
					class="caution mb_0 d_flex justify_start"
					v-if="toAccountNumber && isCheckAccount && !toAccountInfo"
					>{{ $t('rtr_pay-payment.caution') }}</span
				>
			</div>
			<div
				class="mb_16"
				v-if="toAccountNumber && isCheckAccount && toAccountInfo"
			>
				<p class="mb_8 tal">{{ $t('rtr_pay-payment.recipient') }}</p>
				<input type="text" :value="toAccountInfo.user_name" disabled />
			</div>
			<div>
				<p class="mb_8 tal">{{ selectedAccountInfo?.asset_code }}</p>
				<input type="text" placeholder="0" v-model="sendAmount" />
			</div>
		</div>
		<button
			class="button_bg_red button_m"
			@click="toCheck"
			:disabled="!canSend"
		>
			{{ $t('button.send') }}
		</button>
	</ModalViewM>
	<ModalViewM v-if="showTab === 'way2'" @closeModal="closeWayModal">
		<template #title>
			<h3 class="modal_title_m mb_16">{{ $t('rtr_pay-payment.text2') }}</h3>
		</template>
		<div class="mb_16 registration_wrap">
			<p class="mb_8 tal">{{ $t('rtr_pay-payment.text6') }}</p>
			<div class="d_flex align_items_center">
				<div class="search_area w100 mr_8">
					<input
						type="text"
						:placeholder="$t('rtr_pay-payment.text7')"
						v-model="toWalletAddress"
						@focusin="showQrReader = false"
					/>
					<a class="search_icon SEARCH"></a>
				</div>
				<span class="CAMERA" @click="initQrReader = true"></span>
			</div>
		</div>
		<div class="mb_40 registration_wrap">
			<p class="text_type01">{{ $t('rtr_pay-payment.text8') }}</p>
			<input type="text" placeholder="0" v-model="sendAmount" />
		</div>
		<button
			class="button_bg_red button_m"
			@click="toCheck"
			:disabled="!canSend"
		>
			{{ $t('button.send') }}
		</button>
	</ModalViewM>
	<ModalViewM v-if="qrModal" @closeModal="closeWayModal">
		<h3 class="modal_title_m tal">{{ $t('rtr_pay-payment.text9') }}</h3>
		<div v-if="counting" class="qr_area">
			<div class="qr_image_wrap type_01">
				<Qrcode
					:color="{ dark: '#000000ff', light: '#ffffffff' }"
					type="image/png"
					:quality="1"
					:margin="1"
					:value="qrData"
				/>
			</div>
			<div class="timer_area mt_10">
				<p>{{ $t('rtr_pay-payment.text10') }}</p>
				<span class="ml_10">{{ time }}</span>
				<a @click="resetHandler" class="ml_10">
					<img src="@/assets/images/icon/reload.png" alt="" />
				</a>
			</div>
		</div>

		<div v-else class="qr_area">
			<div class="qr_image_wrap type_01 base">
				<div class="mask"></div>
				<img
					class="qr_img"
					src="@/assets/images/qr_sample.jpg"
					alt="sample qr image"
				/>
				<div class="information">
					<p>{{ $t('rtr_pay-payment.text11') }}</p>
					<div class="d_flex justify_center mt_20">
						<img
							class="mr_5"
							src="@/assets/images/icon/reload_w.png"
							alt="reload icon image"
							@click="resetHandler"
						/>
						<span>{{ $t('rtr_pay-payment.text12') }}</span>
					</div>
				</div>
			</div>
			<div class="timer_area mt_10">
				<a @click="resetHandler"
					>{{ $t('rtr_pay-payment.text13') }}
					<img src="@/assets/images/icon/reload.png" alt=""
				/></a>
			</div>
		</div>
	</ModalViewM>
	<ModalViewM v-if="isTransferCheck" @closeModal="closeCheckModal">
		<!-- 송금 하기 전에 확인 -->
		<template #title>
			<h3 class="modal_title_m mb_16">{{ checkModalTitle }}</h3>
		</template>
		<div class="bg_black_box mb_40">
			<div v-if="selectedWay === 'way1'">
				<div class="d_flex justify_between mb_4">
					<span class="fs_14">{{ $t('rtr_pay-payment.modal.recipient') }}</span>
					<span>{{ toAccountInfo?.user_name }}</span>
				</div>
				<div class="d_flex justify_between">
					<span class="fs_14">{{
						$t('rtr_pay-payment.modal.account_number')
					}}</span>
					<span>{{ toAccountInfo?.account_number }}</span>
				</div>
			</div>
			<div v-if="selectedWay === 'way2'">
				<p class="address_wrap_title">
					{{ $t('rtr_pay-payment.modal.wallet_account') }}
				</p>
				<p class="address_wrap">{{ toWalletAddress }}</p>
			</div>
			<span class="divide_line"></span>
			<div class="d_flex justify_between align_items_center pt_16">
				<span class="fs_14">{{
					$t('rtr_pay-payment.modal.payment_amount')
				}}</span>
				<div class="num_unit">
					<p class="num">{{ sendAmount }}</p>
					<p class="unit">{{ selectedAccountInfo?.asset_code }}</p>
				</div>
			</div>
		</div>
		<p class="mb_40 body_l">{{ $t('rtr_pay-payment.modal.check_info') }}</p>
		<button class="button_bg_red button_m" @click="accountTransferHandler">
			{{ $t('button.send') }}
		</button>
	</ModalViewM>
	<ModalMessageM
		v-if="isSuccessTransfer"
		@closeModal="isSuccessTransfer = false"
	>
		<span class="status_icon success mb_8"></span>
		<p class="mb_40">{{ $t('rtr_pay-payment.modal.success') }}</p>
		<button class="button_bg_red button_m" @click="toActivity">
			{{ $t('button.confirm') }}
		</button>
	</ModalMessageM>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="['status_icon ' + modalIcon, 'mb_8']"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<button class="button_bg_red button_m" @click="messageModal = false">
			{{ $t('rtr_auth-register.confirm') }}
		</button>
	</ModalMessageM>
	<div v-show="showQrReader">
		<QrReader
			v-if="initQrReader"
			@close="(showQrReader = false), (initQrReader = false)"
			@onCompleteInit="showQrReader = true"
			@onError="initQrReader = false"
			@onCompleteDecode="onDecode"
		></QrReader>
	</div>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import '@/assets/css/payment.m.css';
import AccountPicker from '@/components/AccountPicker.vue';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import { createAccountTransfer, fetchAccount } from '@/api/account';
import { commonError } from '@/common/dialog';
import { createWithdraw } from '@/api/withdraw';
import { createXptxToken, fetchXptxToken } from '@/api/pg';
import QrReader from '@/components/QrReader';
import {
	createWithdrawAddress,
	deleteWithdrawAddress,
	fetchWithdrawAddressList,
} from '@/api/kyc';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';

export default {
	name: 'Payment.m',
	components: {
		ModalViewM,
		AccountPicker,
		ModalMessageM,
		QrReader,
		Tutorial,
	},
	props: {
		seq: {
			type: Number,
		},
	},
	data() {
		return {
			modules: [Navigation],
			showTab: null,
			selected: false,
			selectedAccountSeq: 0,
			selectedWay: '',
			isTransferCheck: false,
			isSuccessTransfer: false,
			isSelectedAccount: false,
			modalAddStep: 0,
			checked: false,
			messageModal: false,
			modalIcon: 'error',
			modalStatusMessage: '',
			toAccountNumber: '',
			toAccountInfo: null,
			sendAmount: null,
			toWalletAddress: '',
			tokenInfo: {},
			timer: null,
			time: '',
			timeRemaining: null,
			counting: true,
			modalWay1: '',
			modalWay2: '',
			modalWay3: '',
			qrModal: false,
			isCheckAccount: false,
			showQrReader: false,
			initQrReader: false,
			withdrawAddressList: [],
			tour: null,
			showTutorial: false,
			qrData: '',
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		...mapGetters('lang', ['lang']),

		own_assets_items() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(asset_item => {
				if (group.includes(asset_item.seq)) data.push(asset_item);
			});
			return data;
		},
		selectedAccountInfo() {
			return this.accounts.find(account => {
				return account.seq === parseInt(this.selectedAccountSeq);
			});
		},
		canSend() {
			if (this.selectedWay === 'way1') {
				return (
					this.selectedAccountInfo && this.toAccountInfo && this.sendAmount
				);
			} else if (this.selectedWay === 'way2') {
				return this.selectedAccountInfo && this.sendAmount;
			} else {
				return false;
			}
		},
		checkModalTitle() {
			return this.selectedWay === 'way1'
				? this.$t('rtr_pay-payment.text1')
				: this.$t('rtr_pay-payment.text2');
		},
	},
	watch: {
		selectedWay(val) {
			if (val === 'way3') {
				this.createQrToken();
			}
		},
		selectedAccountInfo() {
			// 출금완료 후 qr 모달 뜨는 문제로 주석처리
			// this.selectedWay = 'way3';
			// this.showTab = 'way3';
		},
		toAccountNumber() {
			this.isCheckAccount = false;
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.selectedAccountSeq = this.$route.query.accountSeq;
			this.isSelectedAccount = true;
		}
		this.init();
	},
	methods: {
		init() {
			this.loadWithdrawAddressList();
		},
		initData() {
			this.selectedWay = null;
			this.showTab = '';
			this.showQrReader = false;
			this.initQrReader = false;
			this.toAccountNumber = '';
			this.toWalletAddress = '';
			this.sendAmount = null;
		},
		async loadWithdrawAddressList() {
			const params = {
				no_paging: 1,
				is_valid: 'Y',
			};
			const { data } = await fetchWithdrawAddressList(params).catch(
				commonError,
			);
			this.withdrawAddressList = data;
		},
		toCheck() {
			this.showTab = '';
			this.isTransferCheck = true;
		},
		selectWay(e) {
			if (!this.selectedAccountInfo?.seq) {
				e.target.checked = false;
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				this.messageModal = true;
				return;
			}
			this.showTab = e.target.id;
		},
		checkAsset(e) {
			let selected = e.target.value;
			console.log('selected : ', selected);
		},
		getAccountInfo(accountSeq) {
			this.selectedAccountSeq = accountSeq;
			this.isSelectedAccount = true;
		},
		stepBack() {
			this.modalAddStep--;
		},
		stepNext() {
			this.modalAddStep++;
		},
		toDashboard() {
			this.$router.push({ name: 'auth-dashboard' });
		},
		toActivity() {
			this.$router.push({
				name: 'activity',
				query: { account_seq: this.selectedAccountSeq },
			});
		},
		findAccountInfo() {
			fetchAccount({
				account_seq_or_number: this.toAccountNumber,
				for_transfer: 1,
			})
				.then(result => {
					this.toAccountInfo = result.account_info;
				})
				.catch(commonError)
				.finally(() => {
					this.isCheckAccount = true;
				});
		},
		accountTransferHandler() {
			if (!this.validations()) {
				this.modalIcon = 'success';
				this.messageModalType = 'error';
				this.messageModal = true;
				return;
			}
			switch (this.selectedWay) {
				case 'way1':
					this.accountTransfer();
					break;
				case 'way2':
					this.accountTransferBlock();
					break;
			}
		},
		async accountTransfer() {
			const params = {
				from_seq: this.selectedAccountSeq,
				to_seq: this.toAccountInfo.seq,
				amount: this.sendAmount,
			};
			await createAccountTransfer(params)
				.then(() => {
					this.isTransferCheck = false;
					this.$store.dispatch('account/getAccounts');
					this.isSuccessTransfer = true;
					this.initData();
				})
				.catch(commonError);
		},
		async accountTransferBlock() {
			const withdrawAddressInfo = this.withdrawAddressList.find(item => {
				return item.asset_seq === this.selectedAccountInfo.asset_seq;
			});
			let params = {};
			if (withdrawAddressInfo) {
				await deleteWithdrawAddress(withdrawAddressInfo.seq)
					.then(() => {
						this.loadWithdrawAddressList();
						params = {
							asset_seq: this.selectedAccountInfo.asset_seq,
							address: this.toWalletAddress,
						};
						createWithdrawAddress(params)
							.then(() => {
								this.loadWithdrawAddressList();
								params = {
									account_seq: this.selectedAccountSeq,
									request_amount: this.sendAmount,
								};
								createWithdraw(params)
									.then(() => {
										this.$store.dispatch('account/getAccounts');
										this.isTransferCheck = false;
										this.isSuccessTransfer = true;
										this.initData();
									})
									.catch(commonError);
							})
							.catch(commonError);
					})
					.catch(commonError);
			} else {
				params = {
					asset_seq: this.selectedAccountInfo.asset_seq,
					address: this.toWalletAddress,
				};
				createWithdrawAddress(params)
					.then(() => {
						this.loadWithdrawAddressList();
						params = {
							account_seq: this.selectedAccountSeq,
							request_amount: this.sendAmount,
						};
						createWithdraw(params)
							.then(() => {
								this.$store.dispatch('account/getAccounts');
								this.isTransferCheck = false;
								this.isSuccessTransfer = true;
								this.initData();
							})
							.catch(commonError);
					})
					.catch(commonError);
			}
		},
		async createQrToken() {
			const params = {
				account_seq: this.selectedAccountSeq,
			};
			await createXptxToken(params)
				.then(({ seq }) => {
					this.getQrTokenInfo(seq);
				})
				.catch(commonError);
		},
		async getQrTokenInfo(seq) {
			await fetchXptxToken(seq)
				.then(({ token_info }) => {
					this.tokenInfo = token_info;
					this.qrModal = true;
					this.qrData = `${this.member_info.user_name}|${this.selectedAccountInfo.asset_code}|${this.tokenInfo.auth_code}`;
					this.startTimer();
				})
				.catch(commonError);
		},
		validations() {
			if (!this.selectedAccountInfo) {
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				return false;
			}
			if (!this.selectedWay) {
				this.modalStatusMessage = this.$t('modal.message.select_way');
				return false;
			}
			if (this.selectedWay === 'way1') {
				if (!this.toAccountInfo) {
					this.modalStatusMessage = this.$t('modal.message.check_account');
					return false;
				}
			} else if (this.selectedWay === 'way2') {
				if (!this.toWalletAddress) {
					this.modalStatusMessage = this.$t('modal.message.check_address');
					return false;
				}
			}
			if (!this.sendAmount) {
				this.modalStatusMessage = this.$t('modal.message.set_amount');
				return false;
			}
			return true;
		},
		startTimer() {
			clearInterval(this.timer);
			const now = this.$dayjs();
			const expDate = this.$dayjs(this.tokenInfo.expdate);
			this.timeRemaining = expDate.diff(now, 'second', false);
			this.timeFormatter();
			this.timer = setInterval(() => {
				this.updateTimer();
			}, 1000);
		},
		resetTimer() {
			clearInterval(this.timer);
			this.time = '';
			this.timeRemaining = null;
			this.counting = true;
		},
		timeOut() {
			this.resetTimer();
			this.counting = false;
		},
		updateTimer() {
			if (this.timeRemaining === 0) return this.timeOut();
			this.timeRemaining--;
			this.timeFormatter();
		},
		timeFormatter() {
			const minute =
				this.timeRemaining / 60 < 10
					? '0' + Math.floor(this.timeRemaining / 60)
					: Math.floor(this.timeRemaining / 60);
			const seconds =
				this.timeRemaining % 60 < 10
					? '0' + (this.timeRemaining % 60)
					: this.timeRemaining % 60;
			this.time = minute + ':' + seconds;
		},
		resetHandler() {
			this.counting = true;
			this.createQrToken();
		},
		closeWayModal() {
			if (this.showTab === 'way3') {
				this.resetTimer();
				this.qrModal = false;
			}
			this.initData();
		},
		closeCheckModal() {
			this.initData();
			this.isTransferCheck = false;
		},
		onDecode(result) {
			if (this.showTab === 'way1') {
				this.toAccountNumber = result;
				this.findAccountInfo();
			} else if (this.showTab === 'way2') {
				this.toWalletAddress = result;
			}
			setTimeout(() => {
				this.showQrReader = false;
				this.initQrReader = false;
			}, 1000);
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
	mounted() {
		this.tutorialHandler();
	},
};
</script>
<style scoped></style>
